<agr-dialog [data]="data" (cancel)="cancel()">
  <div class="spacing--margin-top">
    @if (data.soilAnalysis) {
      <table mat-table [dataSource]="data.soilAnalysis.sampledCharacteristics">
        <ng-container matColumnDef="designation">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'soilAnalysisDetailsTable.sampledCharacteristic' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <b>
              {{
                shouldDisplaySoilAnalysisCharacteristicAbbreviation(element.id)
                  ? element.designation
                  : (element.name ?? element.designation)
              }}
            </b>
          </td>
        </ng-container>
        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'soilAnalysisDetailsTable.value' | translate }}
          </th>
          <td
            mat-cell
            *matCellDef="let element"
            [ngClass]="
              element.targetValues
                ? isWithinTargetValues(element.value, element.targetValues)
                  ? 'within-target-values'
                  : 'outside-target-values'
                : ''
            "
          >
            {{ element.value }} {{ element.unitOfMeasurement }}
          </td>
        </ng-container>
        <ng-container matColumnDef="targetValues">
          <th mat-header-cell *matHeaderCellDef>
            {{ 'soilAnalysisDetailsTable.targetValues' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            @if (element.targetValues && targetValuesHasBothMinAndMax(element.targetValues)) {
              <div>{{ element.targetValues?.minimum }} - {{ element.targetValues?.maximum }}</div>
            }
            @if (element.targetValues && !targetValuesHasBothMinAndMax(element.targetValues)) {
              <div>
                {{ element.targetValues?.minimum === 0 ? '<=' : '>=' }}
                {{ element.targetValues?.minimum || element.targetValues?.maximum }}
              </div>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    }
  </div>
</agr-dialog>
